export default __webpack_public_path__ + "static/us-awards-masthead-648e89da8eecb5a1f6e6022e3a421b80.jpeg";